import { type Writable, writable } from 'svelte/store';

import { Cookie } from '@shared/cookies';
import { getCookie, setCookie } from '@utils/cookies';

import { browser } from '$app/environment';

export const showTooltipStore: Writable<boolean> = writable(false);

if (browser) {
    showTooltipStore.set(Boolean(getCookie(Cookie.ShowIncomeTooltip)));
}

export function hideTooltip() {
    setCookie(Cookie.ShowIncomeTooltip, null);
    showTooltipStore.set(false);
}

export function showTooltip() {
    setCookie(Cookie.ShowIncomeTooltip, 'true');
    showTooltipStore.set(true);
}
